import GenericButton from '../button-generic';
import { AppIconType } from '../../lib/typegen/app-icon-type';
import style from './style.module.scss';

export interface CashInsertModalProps {
	denominations: number[];
	runningTotal: number;
	targetAmount: number;
	onInsert: (amount: number) => void;
	onClose: () => void;
}

const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export default function CashInsertModal({ denominations, runningTotal, targetAmount, onInsert, onClose }: CashInsertModalProps) {
	return (
		<dialog open className={style.dialog}>
			<header className={style.dialog__header}>
				<h2 className={style.dialog__title}>Simulate Cash Insertion</h2>
				<p className={style.dialog__subtitle}>Tap a bill to add it to the running total.</p>
			</header>
			<div className={style.dialog__amounts}>
				<div className={style.dialog__amountRow}>
					<span className={style.dialog__amountLabel}>Amount due</span>
					<span className={style.dialog__amountValue}>{currencyFormatter.format(targetAmount)}</span>
				</div>
				<div className={style.dialog__amountRow}>
					<span className={style.dialog__amountLabel}>Amount entered</span>
					<span className={style.dialog__amountValue}>{currencyFormatter.format(runningTotal)}</span>
				</div>
			</div>
			<div className={style.dialog__grid}>
				{denominations.map((amount) => (
					<button key={amount} type='button' className={style.dialog__bill} onClick={() => onInsert(amount)}>
						${amount}
					</button>
				))}
			</div>
			<footer className={style.dialog__footer}>
				<GenericButton icon={AppIconType.CancelSolid} isAltColor={true} innerText='Close' onClick={onClose} isGrowHorizontally={false} />
			</footer>
		</dialog>
	);
}
